export const Product = {
	RMRSCS: 'RMRSCS', // Venta bajo receta archivada
	WP: 'WP', // Venta Bajo Receta
	NP: 'NP', // Venta Libre
	PM: 'PM', // Producto Masivo
	mecanicDiscountOff: 'X % Descuento',
	mecanicNxM: 'N x M',
	auxSlug: 'medicamentos',
};
